"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React, { useRef } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperInstance } from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { FaChevronLeft, FaChevronRight, FaArrowCircleRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
import { shopifyIndustries, ShopifyIndustry } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyIndustriesSliderProps {
  heading?: string;
  subtitle?: string;
  industries?: ShopifyIndustry[];
  buttonText?: string;
  buttonHref?: string;
  className?: string;
}
export default function ShopifyIndustriesSlider(t0) {
  const $ = _c(43);
  const {
    heading: t1,
    subtitle: t2,
    industries: t3,
    buttonText: t4,
    buttonHref: t5,
    className: t6
  } = t0;
  const heading = t1 === undefined ? "Shopify Developers That Excel in Every Industry" : t1;
  const subtitle = t2 === undefined ? "Shopify offers a variety of built-in features to make the most engaging eCommerce stores. Hire the best Shopify developers from The Dezine to help you get the maximum out of Shopify solutions." : t2;
  const industries = t3 === undefined ? shopifyIndustries : t3;
  const buttonText = t4 === undefined ? "Get Started" : t4;
  const buttonHref = t5 === undefined ? "/contact" : t5;
  const className = t6 === undefined ? "" : t6;
  const desktopAnimations = useDesktopAnimations();
  const swiperRef = useRef(null);
  const t7 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  let t9;
  if ($[1] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t10;
  } else {
    t10 = $[4];
  }
  let t11;
  if ($[5] !== desktopAnimations) {
    t11 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  let t13;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      once: true
    };
    t13 = {
      duration: 0.7,
      ease
    };
    $[7] = t12;
    $[8] = t13;
  } else {
    t12 = $[7];
    t13 = $[8];
  }
  let t14;
  if ($[9] !== heading) {
    t14 = <h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[9] = heading;
    $[10] = t14;
  } else {
    t14 = $[10];
  }
  let t15;
  if ($[11] !== subtitle) {
    t15 = subtitle && <p className="font-sans mt-3 text-[14.5px] font-normal leading-[26px] text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>;
    $[11] = subtitle;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t14 || $[16] !== t15 || $[17] !== t9) {
    t16 = <motion.div initial={t9} whileInView={t10} animate={t11} viewport={t12} transition={t13} className="mx-auto mb-12 max-w-3xl text-center md:mb-16">{t14}{t15}</motion.div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t14;
    $[16] = t15;
    $[17] = t9;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => swiperRef.current?.slidePrev();
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <button type="button" onClick={t17} aria-label="Previous industry" className="absolute -left-1 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-[#f6248c] text-white  transition-all duration-200  active:scale-95 sm:-left-3 sm:h-12 sm:w-12 lg:-left-5"><FaChevronLeft className="-ml-0.5 text-sm sm:text-base" /></button>;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => swiperRef.current?.slideNext();
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <button type="button" onClick={t19} aria-label="Next industry" className="absolute -right-1 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-[#f6248c] text-white  transition-all duration-200  active:scale-95 sm:-right-3 sm:h-12 sm:w-12 lg:-right-5"><FaChevronRight className="-mr-0.5 text-sm sm:text-base" /></button>;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  let t21;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = [Autoplay];
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  const t22 = industries.length > 3;
  let t23;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    };
    $[24] = t23;
  } else {
    t23 = $[24];
  }
  let t24;
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = swiper => {
      swiperRef.current = swiper;
    };
    t25 = {
      640: {
        slidesPerView: 2,
        spaceBetween: 24
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 28
      }
    };
    $[25] = t24;
    $[26] = t25;
  } else {
    t24 = $[25];
    t25 = $[26];
  }
  let t26;
  if ($[27] !== industries) {
    t26 = industries.map(_temp2);
    $[27] = industries;
    $[28] = t26;
  } else {
    t26 = $[28];
  }
  let t27;
  if ($[29] !== t22 || $[30] !== t26) {
    t27 = <div className="relative px-2 sm:px-6 lg:px-8">{t18}{t20}<Swiper modules={t21} loop={t22} autoplay={t23} spaceBetween={20} slidesPerView={1} onBeforeInit={t24} breakpoints={t25} className="w-full pb-4">{t26}</Swiper></div>;
    $[29] = t22;
    $[30] = t26;
    $[31] = t27;
  } else {
    t27 = $[31];
  }
  let t28;
  if ($[32] !== buttonHref || $[33] !== buttonText || $[34] !== desktopAnimations) {
    t28 = buttonText && <motion.div initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: 0.25,
      ease
    }} className="mt-14 flex justify-center text-center md:mt-18"><GradientButton href={buttonHref} variant="pink-purple" className=""><span>{buttonText}</span><FaChevronRight className="ml-1 text-[12px]" /></GradientButton></motion.div>;
    $[32] = buttonHref;
    $[33] = buttonText;
    $[34] = desktopAnimations;
    $[35] = t28;
  } else {
    t28 = $[35];
  }
  let t29;
  if ($[36] !== t16 || $[37] !== t27 || $[38] !== t28) {
    t29 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">{t16}{t27}{t28}</div>;
    $[36] = t16;
    $[37] = t27;
    $[38] = t28;
    $[39] = t29;
  } else {
    t29 = $[39];
  }
  let t30;
  if ($[40] !== t29 || $[41] !== t7) {
    t30 = <section className={t7}>{t8}{t29}</section>;
    $[40] = t29;
    $[41] = t7;
    $[42] = t30;
  } else {
    t30 = $[42];
  }
  return t30;
}
function _temp2(industry) {
  return <SwiperSlide key={industry.id} className="!h-auto flex"><article className={`flex h-full w-full flex-col rounded-[20px] p-7 transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(20,50,90,0.1)] sm:p-8 md:p-9 ${industry.bg} ${industry.darkBg || "dark:bg-gray-900"}`}><div className="mb-5 h-14 w-14 sm:h-16 sm:w-16"><Image src={industry.icon} alt={industry.alt} width={64} height={64} loading="lazy" className="h-full w-full object-contain transition-transform duration-300 hover:scale-105" /></div><h3 className="font-poppins mb-3 text-[20px] font-bold leading-tight text-[#0b1354] sm:text-[22px] dark:text-white">{industry.title}</h3><p className="font-sans mb-6 flex-1 text-[14px] leading-[24px] text-[#5e6282] sm:text-[14.5px] dark:text-gray-300">{industry.description}</p><ul className="mt-auto flex flex-col gap-2.5">{industry.features.map(_temp)}</ul></article></SwiperSlide>;
}
function _temp(feature, idx) {
  return <li key={idx} className="flex items-center gap-2.5 font-sans text-[13.5px] text-[#5e6282] sm:text-[14px] dark:text-gray-300"><FaArrowCircleRight className="shrink-0 text-[14px] text-[#64748b] dark:text-gray-400" /><span>{feature}</span></li>;
}